<button id="closebutton" aria-label="close filter options" type="button" (click)="closeDialog()">CLOSE <span class="material-symbols-outlined cancel-icon">
    cancel
</span> </button>
<img src="../../assets/images/development-wheel.png" width="100%" alt="Compass">